import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ZeroStateContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: '500px',
  padding: '48px 24px',
  cursor: 'default',
}));

export const ZeroStateContent = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: '16px',
  padding: '32px',
  textAlign: 'center',
  maxWidth: '500px',
  width: '100%',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  backgroundColor: theme.palette.background.paper,
}));
